import pointManagementQrMethods from "@/controllers/pointManagementQrMethods";
import pointManagementDataMethods from "@/controllers/pointManagementDataMethods";
import pointManagementLifecycle from "@/controllers/pointManagementLifecycle";
import pointManagementTransactionMethods from "@/controllers/pointManagementTransactionMethods";

export default {
  data() {
    return {
      qrInfo: { qrUrl: "", providerName: "", pointEnabled: true },
      qrLoading: true,
      pendingRequests: [],
      pendingLoading: true,
      processingId: null,
      historyItems: [],
      historyTotal: 0,
      historyPage: 1,
      historyLoading: true,
    };
  },
  ...pointManagementLifecycle,
  methods: {
    ...pointManagementQrMethods,
    ...pointManagementDataMethods,
    ...pointManagementTransactionMethods,
  },
};
